export default function UserManagementSkeleton() {
  return (
    <div className="relative flex min-h-[calc(100vh-70px)] animate-pulse flex-col bg-gray-100 px-3 py-10 md:px-6">
      <div className="-my-[40px] -ml-[20px] -mr-[20px] mb-2.5 flex items-center justify-between overflow-x-auto bg-[#fff] px-5 py-3 shadow-[inset_20px_0_20px_-20px_rgba(0,0,0,0.1),inset_-20px_0_20px_-20px_rgba(0,0,0,0.1)] max-xl:-ml-[10px] max-xl:-mr-[10px]">
        <div className="scrollbar-hide flex flex-1 space-x-4 overflow-x-auto border-b border-neutral-200 pr-4">
          {Array.from({ length: 4 }, (_, index) => (
            <div
              key={index}
              className="shrink-0 whitespace-nowrap px-4 py-2"
            >
              <div
                className={`h-4 w-20 rounded bg-neutralLight ${index === 0 ? 'w-16' : 'w-24'}`}
              />
            </div>
          ))}
        </div>

        <div className="ml-2 shrink-0 rounded-full bg-gray-100 p-2">
          <div className="h-6 w-6 rounded bg-neutralLight" />
        </div>
      </div>

      <div className="h-max-[624px] !h-min-[30vh] mb-6 overflow-auto rounded-xl border border-gray-200 bg-white pb-14">
        <table className="relative min-w-full divide-y divide-gray-200 bg-white">
          <thead className="h-12 text-sm font-semibold uppercase text-neutralSemiDark">
            <tr className="border-b border-gray-200">
              <th className="px-3 py-4 text-left text-sm font-medium tracking-wide text-gray-600 xl:px-6">
                <div className="h-4 w-16 rounded bg-neutralLight" />
              </th>
              <th className="px-3 py-4 text-left text-sm font-medium uppercase tracking-wide text-gray-600 xl:px-6">
                <div className="h-4 w-32 rounded bg-neutralLight" />
              </th>
              <th className="px-3 py-4 text-left text-sm font-medium uppercase tracking-wide text-gray-600 xl:px-6">
                <div className="h-4 w-20 rounded bg-neutralLight" />
              </th>
              <th className="px-3 py-4 text-left text-sm font-medium uppercase tracking-wide text-gray-600 xl:px-6"></th>
              <th className="w-20"></th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200 text-gray-700">
            {Array.from({ length: 8 }, (_, index) => (
              <tr key={index}>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <div className="h-8 w-8 rounded-full bg-neutralLight" />
                    <div className="flex flex-col">
                      <div className="mb-1 flex items-center gap-2">
                        <div className="h-4 w-32 rounded bg-neutralLight" />
                        <div className="h-4 w-16 rounded bg-neutralLight" />
                      </div>
                      <div className="h-3 w-40 rounded bg-neutralLight" />
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <div className="h-4 w-32 rounded bg-neutralLight" />
                </td>
                <td className="px-6 py-4">
                  <div className="h-4 w-24 rounded bg-neutralLight" />
                </td>
                <td className="px-6 py-4"></td>
                {/* <td className="px-6 py-4">
                                    <div className="h-7 w-16 rounded border border-neutralLight bg-white" />
                                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination Skeleton */}
      <div className="mt-auto flex w-[calc(100%)] items-center justify-between px-2">
        <div className="flex items-center gap-2">
          <div className="h-4 w-48 rounded bg-neutralLight" />
          <div className="h-8 w-16 rounded border border-gray-300 bg-white" />
        </div>
        <div className="flex items-center justify-center gap-2">
          <div className="h-8 w-8 rounded border border-gray-300 bg-white" />
          <div className="h-8 w-8 rounded border border-gray-300 bg-white" />
        </div>
      </div>
    </div>
  );
}
